import { useEffect } from 'react';
import App from '@/components/app/app';
import CommitMessage from '@/components/commit-message';
import DialogDispatcher from '@/components/dialog-dispatcher';
import useBaseApiUrl from '@/hooks/useBaseApiUrl';
import useCmpPopupFix from '@/hooks/useCmpPopupFix';
import useConfigFromExperiment from '@/hooks/useConfigFromExperiment';
import useGenerateLeadId from '@/hooks/useGenerateLeadId';
import useGetLogosFromAssets from '@/hooks/useGetLogosFromAssets';
import useMouseFlow from '@/hooks/useMouseFlow';
import useStoreQidData from '@/hooks/useStoreQidData';
import Track from '@/utils/track';
import '@/components/leadfunnel/leadfunnel.css';

const getId = () => (window.location.pathname.indexOf('bussgeldcheck') === -1 ? 'dev' : 'prod');

const Leadfunnel = () => {
  useCmpPopupFix();
  useConfigFromExperiment();
  useGenerateLeadId();
  useGetLogosFromAssets();
  useMouseFlow();
  useStoreQidData();
  useBaseApiUrl();

  useEffect(() => {
    Track.DataLayer.UuidV4();
  }, []);

  useEffect(() => {
    Track.Experiments.StartPage();
  }, []);

  return (
    <div id={getId()}>
      <CommitMessage />
      <App />
      <DialogDispatcher />
    </div>
  );
};

export default Leadfunnel;
